// extracted by mini-css-extract-plugin
export var root = "anchor-module--root--f328a";